import React, { useContext } from 'react';
import StyledContainer from './StyledContainer';
import StyledImage from './StyleImage';
import defaultLogo from '../assets/images/logo_default.svg';
import StylesContext from '../context/StylesContext';
import { useLanguage } from '../hooks/languageService';

interface MainLogoContainerProps {
  wrapperClass?: string;
  logoClass?: string;
}

const MainLogoContainer: React.FC<MainLogoContainerProps> = ({ wrapperClass, logoClass }) => {
  const { styles } = useContext(StylesContext);

  return (
    <StyledContainer className={wrapperClass}>
      <StyledContainer className={logoClass}>
        <StyledImage src={ styles?.logoImg || defaultLogo }/>      
      </StyledContainer>
    </StyledContainer>
  )
}

export default MainLogoContainer;